export const serviceCategorySidebarNavigatorIconTokens = [
  "arrowRight",
  "chevronRight",
  "search",
  "plus",
  "minus",
  "x",
  "settings",
  "wrench",
  "layers",
  "list",
  "sparkles",
  "shieldCheck",
  "heroArrowRight",
  "heroChevronRight",
  "heroSearch",
  "heroPlus",
  "heroMinus",
  "heroXMark",
  "heroCog",
  "heroWrenchScrewdriver",
  "heroSquares",
  "heroListBullet",
] as const;

export type ServiceCategorySidebarNavigatorIconToken =
  (typeof serviceCategorySidebarNavigatorIconTokens)[number];

export const serviceCategorySidebarNavigatorTokens = {
  colors: {
    background: "#ffffff",
    surface: "#ffffff",
    serviceSurface: "#f7faff",
    serviceSurfaceHover: "#eef6ff",
    text: "#071735",
    textSoft: "#25334d",
    textMuted: "#617089",
    accent: "#075ed6",
    accentContrast: "#ffffff",
    border: "rgba(7, 23, 53, 0.11)",
    strongBorder: "rgba(7, 23, 53, 0.16)",
    searchBackground: "#ffffff",
    iconBackground: "#eef6ff",
    shadow: "0 18px 48px rgba(7, 23, 53, 0.1)",
    hoverShadow: "0 18px 42px rgba(7, 23, 53, 0.14)",
  },
  icons: {
    search: "search",
    clear: "x",
    category: "settings",
    categoryArrow: "chevronRight",
    serviceArrow: "chevronRight",
    expand: "plus",
    collapse: "minus",
    cta: "arrowRight",
  },
  radius: {
    panel: 8,
    search: 7,
    category: 8,
    service: 5,
    icon: 999,
    focus: 8,
  },
  sizes: {
    maxWidth: 380,
    categoryIcon: 38,
    categoryAction: 30,
    serviceArrow: 16,
    ctaIcon: 15,
  },
  spacing: {
    panel: 18,
    headerGap: 8,
    sectionGap: 16,
    categoryGap: 10,
    categoryPadding: 12,
    serviceGap: 6,
    servicePaddingY: 10,
    servicePaddingX: 11,
  },
  typography: {
    fontFamily:
      'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    title: {
      fontSize: 22,
      lineHeight: 1.1,
      fontWeight: 850,
      letterSpacing: 0,
    },
    description: {
      fontSize: 12,
      lineHeight: 1.45,
      fontWeight: 500,
      letterSpacing: 0,
    },
    cta: {
      fontSize: 12,
      lineHeight: 1,
      fontWeight: 800,
      letterSpacing: 0,
    },
    search: {
      fontSize: 12,
      lineHeight: 1.2,
      fontWeight: 550,
      letterSpacing: 0,
    },
    categoryTitle: {
      fontSize: 13,
      lineHeight: 1.18,
      fontWeight: 850,
      letterSpacing: 0,
    },
    categoryDescription: {
      fontSize: 11,
      lineHeight: 1.35,
      fontWeight: 500,
      letterSpacing: 0,
    },
    serviceTitle: {
      fontSize: 12,
      lineHeight: 1.2,
      fontWeight: 650,
      letterSpacing: 0,
    },
    serviceDescription: {
      fontSize: 11,
      lineHeight: 1.35,
      fontWeight: 500,
      letterSpacing: 0,
    },
    support: {
      fontSize: 12,
      lineHeight: 1.4,
      fontWeight: 500,
      letterSpacing: 0,
    },
    empty: {
      fontSize: 12,
      lineHeight: 1.4,
      fontWeight: 600,
      letterSpacing: 0,
    },
  },
  motion: {
    panel:
      "border-color 180ms ease, background-color 180ms ease, box-shadow 180ms ease, transform 180ms ease",
    icon: "background-color 180ms ease, color 180ms ease, transform 180ms ease",
    arrow: "color 180ms ease, transform 180ms ease",
    list: "grid-template-rows 180ms ease, opacity 180ms ease",
  },
} as const;

export type ServiceCategorySidebarNavigatorColorToken =
  keyof typeof serviceCategorySidebarNavigatorTokens.colors;
